exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".donatebutton{margin-top:20px}.donation-desc{margin-bottom:30px}@media (max-width: 767px){.donation-desc{margin-bottom:50px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/HomeElements/HowToDonate.scss
// module id = 1050
// module chunks = 0